import React from 'react';

import styles from './ViewDetailsContainer.module.css';

const ViewDetailsContainer = props => {
  return <div className={styles.container}>{props.children}</div>;
};

export default ViewDetailsContainer;
